import { call, put, select } from 'redux-saga/effects';

import { requestFailed } from '../../app/actions/RequestFailedAction';
import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { FlowDetailInfo } from '../../ts/models/FlowInfo';
import { ContentActions } from '../../ts/services/ContentActions';
import { EditFlowReduxAction } from '../actions/EditFlowReduxAction';
import { getFlowDetailInfo } from '../FlowsSagaHelpers';
import { ContentDraftStatus } from '../../ts/ServerApi/types/ContentDraft';
import { SpacesSiteUrls } from '../../app/spaces/SpacesSiteUrls';
import { siteUrlsSelector } from '../../app/selectors/SiteUrlsSelectors';

export function* handleEditFlow(action: EditFlowReduxAction) {
  try {
    const flow = action.flow;
    const contentActions = ServiceLocator.get<ContentActions>('ContentActions');
    if (flow.draftStatus === ContentDraftStatus.unpublished) {
      const urls: SpacesSiteUrls = yield select(siteUrlsSelector);
      contentActions.editUnpublishedFlowDraft(urls, flow.draftLuid);
    } else {
      const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
      const flowDetailInfo: FlowDetailInfo = yield call(getFlowDetailInfo, flow.id);
      contentActions.editFlow(siteUrlName, flowDetailInfo.luid);
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
